import {
  REQUEST_FOR_QUOTE_FILTER_DATA_KEY,
  filterRowsToSaved,
  readSavedFilterRows,
  type SavedFilterRow,
} from '~/types/filters';
import {
  isCollectionField,
  operatorsForField,
  type RequestForQuoteFilterRow,
} from './requestForQuoteFilters';

export type RequestForQuoteFilterData = {
  [REQUEST_FOR_QUOTE_FILTER_DATA_KEY]: SavedFilterRow[];
};

const REQUEST_FOR_QUOTE_SAVED_ROW_SCHEMA = {
  operatorsForField,
  isListField: isCollectionField,
};

export function rowsToFilterData(
  rows: RequestForQuoteFilterRow[]
): RequestForQuoteFilterData {
  return { [REQUEST_FOR_QUOTE_FILTER_DATA_KEY]: filterRowsToSaved(rows) };
}

function hasFilterRows(
  filterData: unknown
): filterData is RequestForQuoteFilterData {
  return (
    typeof filterData === 'object' &&
    filterData !== null &&
    REQUEST_FOR_QUOTE_FILTER_DATA_KEY in filterData
  );
}

export function readRequestForQuoteRows(
  filterData: unknown
): RequestForQuoteFilterRow[] {
  if (!hasFilterRows(filterData)) return [];
  return readSavedFilterRows(
    filterData[REQUEST_FOR_QUOTE_FILTER_DATA_KEY],
    REQUEST_FOR_QUOTE_SAVED_ROW_SCHEMA
  );
}
